import * as TabsPrimitive from "@radix-ui/react-tabs";
import * as React from "react";

import { cn } from "~/lib/utils";

const FolderTabs = TabsPrimitive.Root;

const FolderTabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <>
    <TabsPrimitive.List ref={ref} className={cn(className, "flex gap-2 pl-4")} {...props} />
    <div className="h-px w-full border-t mt-[-1px] mb-[-1px]" />
  </>
));
FolderTabsList.displayName = TabsPrimitive.List.displayName;

const FolderTabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & {
    currentlySelected: string;
  }
>(({ className, currentlySelected, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "border border-b bg-secondary md:hover:bg-card rounded-t-lg p-2 cursor-pointer",
      {
        "border-b-3 border-b-background z-10 bg-background": props.value === currentlySelected,
      },
      className,
    )}
    {...props}
  />
));
FolderTabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

export { FolderTabs, FolderTabsList, FolderTabsTrigger };
